import { asSingleStyleConfig } from '../../../../utils/theme';
import { Input } from './input';
var baseStyle = () => ({
  root: {
    '--number-input-stepper-width': '16px',
    '--number-input-stepper-height': '16px',
    '--number-input-field-padding': 'calc(var(--number-input-stepper-width))'
  },
  stepper: {
    pr: 0
  },
  stepperGroup: {
    top: '5px',
    height: '32px'
  },
  incrementIcon: {
    width: '16px',
    height: '16px'
  },
  decrementIcon: {
    width: '16px',
    height: '16px'
  }
});
export var NumberInput = asSingleStyleConfig({
  baseStyle,
  variants: Input.variants
});